import { useState, useReducer } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext.ts";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { connection } from "utils/apiConnection.ts";
import Loader from "utils/Loader";
import { ACCESS_LEVEL } from "constant/constant";
import type { UserInformation } from "./AuthenticationContext";
import ReducerFunction, { ActionTypes } from "./authenticationReducer.ts";
import Swal from "sweetalert2";
import Encryption from "utils/Encryption.ts";

// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]

export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const [state, dispatch] = useReducer(ReducerFunction, {
    userInfo: {
      id: 0,
      token: "",
      fullName: "",
      mobile: "",
      access_level: [],
      supplier_id: [],
    },
    isLogin: false,
  });

  const [isChecked, setIsChecked] = useState<boolean>(false);

  function login(token: string, info: any, checkAL: false): void {
    let al = info.access_level.map((value) => value.value);
    let sl = info.access_level.reduce(
      (total, value) =>
        total.includes(value.supplier_id)
          ? total
          : [...total, value.supplier_id],
      []
    );
    if (checkAL === true) {
      let temp = Cookies.get("AL");
      if (typeof temp !== "undefined") {
        al = Encryption.decode(temp);
        al = al.split(",");
      }
      temp = Cookies.get("SL");
      if (typeof temp !== "undefined") {
        sl = Encryption.decode(temp);
        sl = sl.split(",");
      }
    }
    al = al.map((value) => ({
      label: ACCESS_LEVEL[value],
      code: +value,
    }));

    dispatch({
      type: ActionTypes.Login,
      payload: {
        id: info.id,
        token,
        fullName: info.fullname,
        mobile: info.mobile,
        access_level: al,
        supplier_list: sl,
      },
    });

    Cookies.set(
      "AL",
      Encryption.encode(al.map((value) => value.code).join(","))
    );
    Cookies.set("SL", Encryption.encode(sl.join(",")));
    Cookies.set("token", token, { expires: 30 });
  }

  async function checkCookie(): Promise<void> {
    //console.log("checkCookie***************");
    let result = await connection("api/checklogininfo", {});
    if (+result.status === 1) {
      login(result.data.usertoken, result.userinfo, true);
    } else {
      let token = Cookies.get("token");
      if (typeof token === "undefined") {
        Cookies.set("token", result.data.usertoken, { expires: 30 });
      }
    }

    setIsChecked(true);
  }

  async function grantPermissions(uid): Promise<void> {
    connection("api/grant_permission", {
      uid,
    }).then((res) => {
      if (+res.status === 1) {
        let al = res.data.map((value) => ({
          label: ACCESS_LEVEL[value.value],
          code: +value.value,
        }));
        let sl = res.data.reduce(
          (total, value) =>
            total.includes(value.supplier_id)
              ? total
              : [...total, value.supplier_id],
          []
        );
        dispatch({
          type: ActionTypes.GrantPermission,
          payload: { access_level: al, supplier_list: sl },
        });

        Cookies.set(
          "AL",
          Encryption.encode(al.map((value) => value.code).join(","))
        );
        Cookies.set("SL", Encryption.encode(sl.join(",")));
        Swal.fire({
          title: "دسترسی با موفقیت اعمال شد.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          title: "خطا!!",
          text: "مشکلی در اعمال دسترسی بوجود آمده است، لطفا بعدا امتحان کنید.",
          icon: "error",
        });
      }
    });
  }

  async function logout(): Promise<void> {
    let result = await connection("api/logout", {});
    if (+result.status === 1) {
      dispatch({ type: ActionTypes.Logout });
      Cookies.set("token", result.data.usertoken, { expires: 30 });
      Cookies.remove("AL");
      Cookies.remove("SL");
    } else {
      toast.error(
        "خارج شدن از سیستم با مشکل مواجه شده است، لطفا بعدا امتحان کنید."
      );
    }
  }

  function changeName(fullname: string): void {
    dispatch({
      type: ActionTypes.ChangeInfo,
      payload: { fullname },
    });
  }

  useEffect(() => {
    checkCookie();
  }, []);

  console.log("userInfo :>> ", state.userInfo);

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          userInfo: state.userInfo,
          isLogged: state.isLogin,
          isChecked,
          login,
          logout,
          grantPermissions,
          changeName,
        }}
      >
        {isChecked ? children : <Loader />}
      </AuthenticationContext.Provider>
    </>
  );
}
